import React, { useEffect, useMemo, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { connect, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import TabComponent from "../../common/Components/TabComponent";
import AlertDialogBox from "../../common/Components/AlertDialogBox";
import ViewAllAlerts from "../../common/Components/ViewAllAlerts";
import PowerBIReportEmbed from '../PowerBIReportEmbed';
import { setActiveEventsCount, setActiveScenarios, setMapData, setPowerBiData, setScenarios, setSelectedScenariosRR } from '../../store/Actions';
import { useSNOTabs } from '../../common/hooks/snoRolebasedAccess';
import { setViewPowerBi } from '../../store/Actions';
import useTabList from '../../common/TabList';
import GraphService from '../../services/console_services/Graph';
import MapService from '../../services/console_services/Map';
import KPIService from '../../services/console_services/KPI';
import UserDetailsServices from '../../services/console_services/LoginLogot';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2.5, 2.5, 1.25, 10),
    fontFamily: theme.fontFamily,
  },
  gridItem: {
    paddingTop: theme.spacing(2),
  },
}));

const Rapid_Response = ({
  tabIndex,
  Network,
  DC,
  Products,
  applyFilter,
  Division,
  PL3,
  periodType,
  role,
  viewPowerBi,
  setViewPowerBi,
  rapidResponseDates
}) => {

  const classes = useStyles();
  const { instance } = useMsal();
  const [viewAll, setViewAll] = useState(false);
  const [KPIData, setKPIData] = useState({});
  const [KPILoading, setKPILoading] = useState(true);
  const [mapData, setMapData] = useState([]);
  const [MapLoading, setMapLoading] = useState(false);
  const dispatch = useDispatch();
  const TabList = useTabList();
  const currentTabData = useMemo(() => TabList["SNO_DOM_RR"][tabIndex], [tabIndex]);
  const recomFlagValue = useSelector((state) => state?.filter?.recomFlag);
  const selectedScenarios = useSelector((state) => state?.filter?.selectedScenarios);
  const selectedNetworks = useSelector((state) => state?.filter?.selectedNetworks);

  useEffect(() => {
    const fetchMapData = async () => {
      const params = {
        name: currentTabData.value,
        Level: role,
        acceptCondition: recomFlagValue,
        scenarioCondition: selectedScenarios?.map((item) => item?.value),
        filter: {
          RecommendedDC: DC,
          Network,
          PL3,
          Division,
          Products,
          startDate: rapidResponseDates[0],
          endDate: rapidResponseDates[1],
        },
      };
      setMapLoading(true);
      MapService.getMAP(params, instance).then(data => {
        if (data?.data) {
          setMapData(data?.data);
        }
      })
        .catch(error => console.error('Error:', error))
        .finally(() => setMapLoading(false));
    };
    fetchCreateAlertsWithUser();
    fetchMapData();
  }, [tabIndex, role, applyFilter, DC, Network, PL3, Division, Products, rapidResponseDates, recomFlagValue, selectedScenarios]);

  const fetchCreateAlertsWithUser = () => {
    if (currentTabData.value) {
      UserDetailsServices.createAlertsWithUser({
        module: currentTabData.value
      }, instance);
      UserDetailsServices.createAlertsWithThresholdUser({
        module: currentTabData.value
      }, instance);
    }
  };


  useEffect(() => {
    const fetchKPIData = async () => {
      const params = {
        name: currentTabData.value,
        periodType,
        Level: role,
        acceptCondition: recomFlagValue,
        scenarioCondition: selectedScenarios?.map((item) => item?.value),
        filter: {
          RecommendedDC: DC,
          Network,
          PL3,
          Division,
          Products,
          startDate: rapidResponseDates[0],
          endDate: rapidResponseDates[1],
        },
      };

      setKPILoading(true);
      KPIService.getKPI(params, instance).then(data => {
        if (data?.response) {
          setKPIData(data?.response);
        }
      })
        .catch(error => console.error('Error:', error))
        .finally(() => setKPILoading(false));
    };
    fetchKPIData();
  }, [tabIndex, periodType, role, applyFilter, DC, Network, recomFlagValue, selectedScenarios]);

  const getScenariosData = async () => {
    const params = { 
      Module: "RR",
      Network: selectedNetworks?.length === 0 ? ["ALL"] : selectedNetworks,
     };
    GraphService.getScenariosRR(params, instance).then(data => {
      if (data?.data) {
        const scenariosData = data?.data?.map(item => ({ entity: "scenarioName", value: item }));
        dispatch(setScenarios(scenariosData));
      }
    })
      .catch(error => console.error('Error:', error));

  };

  useEffect(() => {
    getScenariosData();
  }, []);

  useEffect(()=>{
    getScenariosData();
  }, [selectedNetworks]);

  useEffect(() => {
    const getActiveScenariosData = async () => {
      const params = {};
      GraphService.getActiveScenarios(params, instance).then(data => {
        if (data?.data) {
          dispatch(setActiveScenarios(data?.data));
          dispatch(setSelectedScenariosRR(data?.data));
        }
      })
        .catch(error => console.error('Error:', error));

    };
    getActiveScenariosData();
  }, []);

  useEffect(() => {
    const getActiveEventCountsData = async () => {
      const params = {};
      GraphService.getActiveEventCounts(params, instance).then(data => {
        if (data?.data) {
          dispatch(setActiveEventsCount(data?.data[0]?.Active_Events));
        }
      })
        .catch(error => console.error('Error:', error));

    };
    getActiveEventCountsData();
  }, []);

  const toggleViewAll = () => setViewAll(!viewAll);
  const toggleViewPowerBi = (val) => {
    setViewPowerBi(!viewPowerBi);
    dispatch(setPowerBiData(val));
  };
  return (
    <Box className={classes.root}>
      {viewPowerBi ? (
        <PowerBIReportEmbed />
      ) : (
        <>
          {!viewAll ? (
            <Grid container spacing={2}>
              <Grid item xs={12} md={9}>
                <TabComponent
                  KPIData={KPIData}
                  mapData={mapData}
                  tabList={TabList["SNO_DOM_RR"]}
                  MapLoading={MapLoading}
                  KPILoading={KPILoading}
                  Module={currentTabData?.name}
                  graphViewTabList={currentTabData?.graphViewTabList}
                />
              </Grid>
              <Grid item xs={12} md={3} className={classes.gridItem} sx={{ mt: '93px' }}>
                <AlertDialogBox
                  handleViewAll={toggleViewAll}
                  handleViewPowerBi={toggleViewPowerBi}
                  viewAll={viewAll}
                />
              </Grid>
            </Grid>
          ) : (
            <ViewAllAlerts viewAll={viewAll} handleClose={toggleViewAll} />
          )}
        </>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  periodType: state.filter.periodType,
  PL3: state.filter.PL3,
  rapidResponseDates: state.filter.rapidResponseDates,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
  viewPowerBi: state.viewPowerBi.viewPowerBi,
});

const mapDispatchToProps = (dispatch) => ({
  setViewPowerBi,
  DateRangeFilterForRapidResponseActions: newValue => dispatch({ type: 'RAPID_RESPONSE_FILTER_DATERANGE', payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Rapid_Response);
